const REPLACERS = [
    [/yyyy|YYYY/, (date) => date.getFullYear()],
    [/yy|YY/, (date) => date.getFullYear().toString().slice(2)],
    ['MM', (date) => DateFormatter.addLeadingZeros(date.getMonth() + 1)],
    ['M', (date) => date.getMonth() + 1],
    ['DD', (date) => DateFormatter.addLeadingZeros(date.getDate())],
    ['D', (date) => date.getDate()],
    ['HH', (date) => DateFormatter.addLeadingZeros(date.getHours())],
    ['H', (date) => date.getHours()],
    ['mm', (date) => DateFormatter.addLeadingZeros(date.getMinutes())],
    ['m', (date) => date.getMinutes()],
    ['ss', (date) => DateFormatter.addLeadingZeros(date.getSeconds())],
    ['s', (date) => date.getSeconds()],
    ['SSS', (date) => date.getMilliseconds()],
    ['SS', (date) => Math.floor(date.getMilliseconds() / 10)],
    ['S', (date) => Math.floor(date.getMilliseconds() / 100)]
];
/**
 * Handles formatting of dates.
 */
export default class DateFormatter {
    /**
     * Formats a date.
     *
     * @param dateString Date string.
     * @returns Formatted date.
     */
    static isoStringToDate(dateString) {
        return new Date(dateString.replace('Z', ''));
    }
    /**
     * Formats a date object to a date string.
     *
     * @param date Date object or string to pass into the Date constructor.
     * @param [format] Format to use. Default is "YYYY-MM-DD".
     * @returns Formatted date.
     */
    static dateToString(date, format = 'YYYY-MM-DD') {
        const parsedDate = date instanceof Date ? date : new Date(date);
        if (isNaN(parsedDate.getTime())) {
            return parsedDate.toString();
        }
        return REPLACERS.reduce((str, [pattern, fnc]) => {
            const arr = str.split(pattern);
            if (arr.length === 1) {
                return arr[0];
            }
            return arr.join(fnc(parsedDate));
        }, format);
    }
    /**
     * Adds leading zeross to a number.
     *
     * @param value Number to add leading zeros to.
     * @returns Number with leading zeros converted to a string.
     */
    static addLeadingZeros(value) {
        value = String(value);
        while (value.length < 2) {
            value = '0' + value;
        }
        return value;
    }
}
//# sourceMappingURL=DateFormatter.js.map